import React, { useEffect, useState } from "react";
import { Table, Button } from "antd"; // Import Table and Button from Ant Design

function SaloonDetail({ allData }) {
  console.log(allData)
  const [data, setData] = useState([]);
  // const [showAllItems, setShowAllItems] = useState({}); // State to manage visibility of items per saloon

  useEffect(() => {
    setData(allData);
  }, [allData]);

  // Define columns for the items table
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "FootFall",
      dataIndex: "footFall",
      key: "footFall",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Gross Income",
      dataIndex: "grossIncome",
      key: "grossIncome",
    },
    {
      title: "Total Time Consumed",
      dataIndex: "totalTimeConsumed",
      key: "totalTimeConsumed",
    },
    {
      title: "Service Time",
      dataIndex: "serviceTime",
      key: "serviceTime",
      render: (text) => `${text} min`, // Adding 'min' suffix
    },
    {
      title: "Created At",
      dataIndex: "created",
      key: "created",
    },
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        {data && data.length > 0 ? (
          data.map((item, index) => (
            <div key={index} className="col-12 mb-4">
                <h5 className="">{item?.shop?.name}</h5>
                <p className="mb-2">Working Days: {item?.shop?.workingDays}</p>
              <div className="card shadow-sm">
                <div className="card-body">
                  {item.items && item.items.length > 0 ? (
                    <div>
                      <Table
                        dataSource={item?.items}
                        columns={columns}
                        pagination={false}
                        rowKey={(record) => record.name} // Use a unique key if available
                      />
                      {/* {item.items.length > 3 && (
                        <Button
                          onClick={() => setShowAllItems((prev) => ({
                            ...prev,
                            [index]: !prev[index]
                          }))}
                          className="mt-2"
                        block>
                          {showAllItems[index] ? 'Show Less' : 'View All'}
                        </Button>
                      )} */}
                    </div>
                  ) : (
                    <p className="text-muted">No items available</p>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12">
            <div className="card text-center">
              <div className="card-body">
                <p className="text-muted">No data available</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SaloonDetail;
